import ServiceCard from './portrait-service-card'
export default ServiceCard
